import {Component, EventEmitter, Input, OnInit, Output, ViewChildren} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {DWPValidatorsService} from '../../dwpvalidators.service';
import {ConfigurableDate} from '../../configurable-date/configurable-date.model';
import {EstimationInput} from './estimation-input.model';

@Component({
  selector: 'app-estimation-input',
  templateUrl: './estimation-input.component.html',
  styleUrls: ['./estimation-input.component.css']
})
export class EstimationInputComponent implements OnInit {
  @Input()
  displayMileage: boolean;
  @Output()
  estimationInput: EventEmitter<EstimationInput> = new EventEmitter<EstimationInput>();
  @ViewChildren('vin')
  inputs;

  form: UntypedFormGroup;
  firstRegistrationFallsWithinRange = true;

  constructor(private formBuilder: UntypedFormBuilder, private validator: DWPValidatorsService) {
  }

  ngOnInit(): void {
    this.setupForm();
  }

  setupForm() {
    this.form = this.formBuilder.group({
      vin: new UntypedFormControl('', [Validators.required, Validators.minLength(17), Validators.maxLength(17)]),
      firstRegistration: new UntypedFormControl('', [Validators.required, this.validator.notBlank]),
      mileage: new UntypedFormControl()
    });

    if (this.displayMileage) {
      this.form.setControl('mileage', new UntypedFormControl('', [this.validator.number, Validators.min(0)]));
    } else {
      this.form.removeControl('mileage');
    }
  }

  emit(): void {
    const firstRegistration: Date = this.form.get('firstRegistration').value;
    this.firstRegistrationFallsWithinRange = this.validator.dateWithinDaysInThePast(firstRegistration, 7000) ||
      this.validator.dateWithinDaysInTheFuture(firstRegistration, 0);

    const estimationInput: EstimationInput = {
      valid: this.form.valid && this.firstRegistrationFallsWithinRange,
      vin: this.form.get('vin').value,
      firstRegistration,
      mileage: this.displayMileage ? parseInt(this.form.get('mileage').value, 10) : undefined,
    };

    if (!this.displayMileage) {
      delete estimationInput.mileage;
    }
    this.estimationInput.emit(estimationInput);
  }

  clearFields(): void {
    this.form.reset();
  }
}
